const STORAGE_PREFIX = "sms_selectedAcademicYearId_v1";

function getStorageKey(tenantId: string) {
  return `${STORAGE_PREFIX}:${tenantId}`;
}

export function readStoredAcademicYearSelection(tenantId: string): string | null {
  try {
    const raw = localStorage.getItem(getStorageKey(tenantId));
    return raw && raw.trim() ? raw : null;
  } catch {
    return null;
  }
}

export function writeStoredAcademicYearSelection(tenantId: string, academicYearId: string) {
  try {
    localStorage.setItem(getStorageKey(tenantId), academicYearId);
  } catch {
    // ignore
  }
}

export function clearStoredAcademicYearSelection(tenantId: string | null | undefined) {
  if (!tenantId) return;
  try {
    localStorage.removeItem(getStorageKey(tenantId));
  } catch {
    // ignore
  }
}
